import L from "leaflet";
import { Marker } from "react-leaflet";
import { VegKamera } from "../../../services/RuteplanAPI";
import vegkameraIconResource from "../../../assets/cctv.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const vegkameraIcon = L.icon({
    iconUrl: vegkameraIconResource,
    iconRetinaUrl: vegkameraIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IVegkameraMarkersProps {
    vegkameraer: Array<VegKamera>;
}

export default function VegkameraMarkers (props: IVegkameraMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();

    const { vegkameraer } = props;

    return (
        <>
            {vegkameraer.map((vegkamera: VegKamera, index: number) => {
                return (
                    <Marker key={vegkamera.cameraId + index} 
                    position={[vegkamera.location!.y, vegkamera.location!.x]} 
                    icon={vegkameraIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(vegkamera);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}